import React, { useState } from "react";
import { Icon } from "@coverme/icons";

export const MiniFacesheetSection = ({ title, children, isExpandable = true, isClickable = true }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onClick = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div className="mini-facesheet__section">
            {isClickable && (
                <div>
                    <div className={`mini-facesheet__section-title ${isOpen && "open"}`} onClick={onClick}>
                        <h4>{title}</h4>
                        {isExpandable && (
                            <span className="mini-facesheet__arrow">
                                <Icon icon={"arrow"} color={"blue"} height={8} />
                            </span>
                        )}
                    </div>
                    <div className="mini-facesheet__income-content">
                        <div className="mini-facesheet__padding">{children}</div>
                    </div>
                </div>
            )}
            {!isClickable && (
                <div>
                    <div className={`mini-facesheet__section-title ${isOpen && "open"}`}>
                        <h4>{title}</h4>
                        {isExpandable && (
                            <span className="mini-facesheet__arrow">
                                <Icon icon={"arrow"} color={"blue"} height={8} />
                            </span>
                        )}
                    </div>
                    <div className="mini-facesheet__income-content">
                        <div className="mini-facesheet__padding">{children}</div>
                    </div>
                </div>
            )}

        </div>
    );
};
